<template>
  <!-- 直播分享 -->
  <div class="live_share">
    <van-overlay :show="showHint" @touchmove.prevent.stop z-index="10003">
      <div>
        <div class="fenxiang1">
          <img src="@assets/img/fenxiang1.png" />
        </div>
        <div class="fenxiang2">
          <img @click="showHint=false" src="@assets/img/fenxiang2.png" />
        </div>
      </div>
    </van-overlay>
    <van-action-sheet :lazy-render="false" @close="dialogClose" cancel-text="Cancel" class="share_dialog" v-model="show">
      <div class="share_content">
        <div @click="showHint=true;show=false" class="share_firend item">
          <img src="@assets/img/icon/wx.png" />
          <p>Friends</p>
        </div>
        <div @click="createP" class="create_poster item">
          <img src="@assets/img/icon/download.png" />
          <p>Poster</p>
        </div>
        <div class="share_ewm">
          <div class="ewm_img" id="qrcode">
            <!-- <img src="http://www.zhanshangxiu.com/static/img/code.8058edb3.jpg" /> -->
          </div>
          <p>Scan code</p>
        </div>
      </div>
    </van-action-sheet>
    <createPoster :options="options" @close="showPoster = false" ref="createPoster" v-if="showPoster"></createPoster>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapActions } from "vuex";
import createPoster from "@/components/create-poster/index";
export default {
  name: "live-share",
  data () {
    return {
      show: false,
      showHint: false, //提示
      posterInfo: {},
      wxShareOption: {},
      options: {},
      showPoster: false,
    };
  },
  components: {
    createPoster
  },
  computed: {},
  created () {
    this.getConfig();
  },
  mounted () {
    this.$nextTick(() => {
      this.getQrCode();
    })
  },
  methods: {
    ...mapActions({
      shareToWechat: 'wxShare/shareToWechat',
      wxSharePage: 'wxShare/wxSharePage',
      getConfig: "wxShare/getConfig"
    }),
    //打开分享模态框
    open (obj) {
      this.options = obj; // 绘制海报的配置；
      // this.wxShareOption=wxData;
      this.show = true;
      // this.$nextTick(()=>{
      //   this.shareTo();
      // })
    },
    //分享模态框关闭
    dialogClose () {
      // this.showHint = false;
    },
    getQrCode () {
      let url = window.location.href;
      let qrcode = new QRCode('qrcode', {
        width: 103,
        height: 103,
        text: url,   // 二维码内容
        correctLevel: 3
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      })
    },
    //生成海报
    createP () {
      this.showHint = false;
      if (this.options.banner.length) {
        this.showPoster = true; // 开启分享的海报
      } else {
        this.$toast.fail('No sharing banner')
      }
      this.$nextTick(() => {
        this.show = false;
      })
    },
    async shareTo (data) {
      const req = {
        title: data.title,
        desc: data.desc,
        link: window.location.href,
        imgUrl: data.imgUrl
      };
      // console.log(req,'req')
      let a = await this.shareToWechat(req);
    }
  },

};
</script>

<style scoped lang="scss">
/* 直播分享 */
.live_share {
  position: relative;
  .live_share_tip {
    z-index: 3000;
  }
  .share_dialog {
    height: 3rem;
    overflow: initial;
    border-radius: 0.15rem 0.15rem 0 0;
    .van-action-sheet__cancel {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 0.9rem;
      font-size: 0.26rem;
      &::before {
        height: 0.02rem;
        background: #e5e5e5;
      }
    }
    .share_content {
      display: flex;
      height: 2.1rem;
      padding: 0.45rem 0.7rem 0;
      justify-content: space-between;
      position: relative;
      .item {
        width: 1.2rem;
        img {
          height: 1rem;
          width: 1rem;
          display: block;
          margin: 0 auto;
        }
        p {
          text-align: center;
          margin-top: 0.1rem;
        }
      }
      .share_ewm {
        position: absolute;
        left: 50%;
        top: -1.2rem;
        text-align: center;
        transform: translateX(-50%);
        .ewm_img {
          width: 2.4rem;
          height: 2.4rem;
          background: #fff;
          padding: 0.17rem;
          border-radius: 0.08rem;
          overflow: hidden;
          margin-bottom: 0.4rem;
          box-shadow: 0px 1px 0.2rem 0.02rem rgba(0, 0, 0, 0.1);
          &::v-deep img {
            width: 100%;
            height: 100%;
          }
        }

        p {
          line-height: 1;
          color: #fd494b;
        }
      }
    }
  }
  &_tip {
    position: fixed;
    z-index: 2020;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    .tip {
      width: 6rem;
      margin-top: 1rem;
    }
    .btn {
      margin-top: 1.5rem;
      width: 2.55rem;
    }
  }
}
.fenxiang1 {
  margin-top: 1.54rem;
  margin-left: 1.64rem;
  img {
    width: 4.58rem;
    height: 2.43rem;
  }
}
.fenxiang2 {
  margin-top: 1.23rem;
  img {
    width: 2.6rem;
    height: 0.78rem;
    margin-left: 2.46rem;
  }
}
::v-deep {
  .van-action-sheet__content {
    overflow-y: inherit;
  }
}
</style>
